import { chainIcons } from 'src/constants/network';
import { nFormatter } from 'src/helpers/formatNumber';
import { Pair } from '@/src/services/token/get-supported-tokens';
import { Dropdown } from 'antd';
import BigNumber from 'bignumber.js';
import { ChevronDown } from 'lucide-react';
import { useMemo, useState } from 'react';
import { NotFoundToken } from 'src/assets/icons';
import { tokenLogos } from 'src/constants/token';
import { useChainId } from 'wagmi';

interface Props {
  onSelectToken: (token: Pair) => void;
  selectedToken?: string;
  supportedTokens?: Pair[];
  balances?: {
    result?: bigint | string | number;
  }[];
  disabled?: boolean;
}

const SelectTokenButton = ({
  onSelectToken,
  selectedToken,
  supportedTokens,
  balances,
  disabled,
}: Props) => {
  const chainId = useChainId();
  const [open, setOpen] = useState(false);

  const dropdownItems = useMemo(() => {
    return supportedTokens?.map((token, index) => {
      return {
        key: token.token_id,
        label: (
          <div>
            <button
              onClick={() => {
                onSelectToken(token);
              }}
              key={token.address}
              className={`token-item flex items-center justify-between w-full`}
            >
              <div className="flex items-center gap-[4px]">
                <div className="relative">
                  <img
                    src={tokenLogos[token.token_id] || NotFoundToken}
                    alt={token.token_id}
                    className="w-[26px] h-[26px] rounded-full mr-2"
                  />
                </div>
                <div className="flex flex-col items-start">
                  <span>{token.token_id}</span>
                  <span className="text-[#888891] text-[12px]">{chainIcons[chainId]?.name}</span>
                </div>
              </div>
              <div className="flex-1 overflow-auto text-end">
                <span>
                  {nFormatter(
                    BigNumber(balances?.[index]?.result?.toString() ?? 0)
                      .div(`1e${token.decimal ?? 18}`)
                      .toString(),
                    4,
                  )}
                </span>
              </div>
            </button>
          </div>
        ),
      };
    });
  }, [supportedTokens, balances]);

  return (
    <Dropdown
      trigger={['click']}
      open={open}
      onOpenChange={setOpen}
      menu={{
        items: dropdownItems,
      }}
      placement="bottom"
      disabled={disabled}
    >
      <button className="flex items-center justify-between gap-[6px]  border-[#494950] border-[1px] px-[12px] py-[8px] rounded-[10px] border-[#494950] border-[1px] w-full h-[51px]">
        <div className="flex items-center gap-[4px]">
          <img
            src={selectedToken ? tokenLogos[selectedToken] ?? NotFoundToken : NotFoundToken}
            alt={selectedToken}
            className="w-6 h-6 rounded-full"
          />
          <span>{selectedToken}</span>
        </div>
        <ChevronDown size={14} />
      </button>
    </Dropdown>
  );
};

export default SelectTokenButton;
